export default __webpack_public_path__ + "static/media/premium-logo.477d0ac4.png";